import { Modal } from 'antd';

function modalMsg({ error, msg, onOk }, supportEmail, context = 'Login') {
  const isNetworkError = error && error.status === 0;
  const modalMsgPath = error
    ? error.status === 0
      ? 'onError.network'
      : `onError.${error.status}`
    : `onSuccess`;
  const modal = Modal[error ? 'error' : 'success'];

  const errorMsg =
    error &&
    error.status !== 400 &&
    error.status !== 401 &&
    error.status !== 403 &&
    error.status !== 404 &&
    error.status !== 500 &&
    !isNetworkError
      ? {
          title: error.title || error.message,
          content: error.detail,
          okText: 'Ok',
        }
      : isNetworkError
      ? {
          title: error.message || 'Network Error',
          content: 'Please check your connection and try again.',
          okText: 'Ok',
        }
      : {};

  const isMissing = val => typeof val === 'string' && val.startsWith('_ERROR_');

  const translatedTitle = msg(`${modalMsgPath}.title`);
  const translatedDescription = msg(`${modalMsgPath}.description`, {
    supportEmail,
  });
  const translatedOkText = msg(`${modalMsgPath}.btn.label`);

  const fallbacks = {
    401: {
      title: 'Incorrect email or password',
      content: 'Please check your credentials and try again.',
    },
  };
  const statusFallback = error && fallbacks[error.status];

  const resolvedTitle =
    errorMsg.title ||
    (isMissing(translatedTitle)
      ? statusFallback?.title || error?.title || error?.message || 'Error'
      : translatedTitle);
  const resolvedDescription =
    errorMsg.content ||
    (isMissing(translatedDescription)
      ? statusFallback?.content ||
        error?.detail ||
        'An error occurred. Please try again.'
      : translatedDescription);
  const resolvedOkText =
    errorMsg.okText || (isMissing(translatedOkText) ? 'Ok' : translatedOkText);

  const toPlainText = val =>
    typeof val === 'string' ? val : (error && error.title) || '';

  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const basePayload = {
      ui_component: 'AuthFormModal',
      form_name: context,
    };
    if (error) {
      window.dataLayer.push({
        event: `${context.toLowerCase()}_error`,
        error_status: error.status === 0 ? 'network' : String(error.status),
        error_title:
          typeof resolvedTitle === 'string' ? resolvedTitle : 'Error',
        error_description: toPlainText(resolvedDescription),
        modal_title: resolvedTitle,
        modal_content: toPlainText(resolvedDescription),
        modal_ok_text: resolvedOkText,
        ...basePayload,
      });
    } else {
      window.dataLayer.push({
        event: `${context.toLowerCase()}_success`,
        modal_title: resolvedTitle,
        modal_content: toPlainText(resolvedDescription),
        modal_ok_text: resolvedOkText,
        ...basePayload,
      });
    }
  }

  modal({
    title: resolvedTitle,
    content: resolvedDescription,
    okText: resolvedOkText,
    okButtonProps: { id: `${modalMsgPath}.btn.label` },
    onOk,
  });
}
export default modalMsg;
